var React = require('react');

function Noimage (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"100%","height":"100%","opacity":".045","key":0}),React.createElement("path",{"d":"M.497 479.54L479.497.5m-479 0l479 479.04","stroke":"#c7c7c7","opacity":".175","strokeWidth":"5","key":1})]);
}

Noimage.defaultProps = {"viewBox":"0 0 480 480","preserveAspectRatio":"none"};

module.exports = Noimage;

Noimage.default = Noimage;
